import { render } from "./TestimonialDetailedView.vue?vue&type=template&id=1e23fb88&scoped=true"
import script from "./TestimonialDetailedView.vue?vue&type=script&lang=js"
export * from "./TestimonialDetailedView.vue?vue&type=script&lang=js"

import "./TestimonialDetailedView.vue?vue&type=style&index=0&id=1e23fb88&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e23fb88"]])

export default __exports__